class RoMediaPlayer extends HTMLElement {
  constructor() {
    super();
    this.mediaPlayer = null;
  }

  connectedCallback() {
    this.mediaPlayer = this.querySelector('media-player');

    if (! this.mediaPlayer) {
      return;
    }

    // Workaround to make the 'loop' property work properly
    this.fixLoop();
  }

  fixLoop() {
    this.mediaPlayer.addEventListener('auto-play', () => {
      const advance = 0.8;
      const replayTime = this.mediaPlayer.duration - advance;

      this.mediaPlayer.subscribe(({ currentTime }) => {
        if (currentTime < replayTime) {
          return;
        }

        this.mediaPlayer.currentTime = 0;
      });
    });
  }
}

customElements.define('ro-media-player', RoMediaPlayer);